import { writable, get } from 'svelte/store';
import { getCart } from './requests.js';

const localePrefix = window.location.pathname.match(/^\/(?<locale>[a-z]{2}(?:-[A-Z]{2})?)(?=\/|$)/)?.groups?.locale || '';
const cartStorageNamespace = `cart:${window.location.host}:${localePrefix || 'default'}`;
export const cartStorageKey = `${cartStorageNamespace}:state`;
export const formStorageKey        = (token) => `${cartStorageNamespace}:form:${token}`;
export const lockerPointStorageKey = (token) => `${cartStorageNamespace}:locker:${token}`;
export const withLocalePrefix = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return localePrefix ? `/${localePrefix}${normalizedPath}` : normalizedPath;
};

let fetchedCart = null;
try { fetchedCart = JSON.parse(localStorage.getItem(cartStorageKey)); } catch(e) { /* corrupted */ }
if (!fetchedCart && !localePrefix) {
  try { fetchedCart = JSON.parse(localStorage.getItem('cart')); } catch(e) { /* corrupted */ }
}
export const cart = writable(fetchedCart || null);

let fetchedFormData = null;
try { fetchedFormData = JSON.parse(localStorage.getItem(formStorageKey(get(cart)?.token))); } catch(e) { /* corrupted */ }
export const formdata = writable(fetchedFormData || null);

export const user = writable();

cart.subscribe(value => {
  localStorage.setItem(cartStorageKey, JSON.stringify(value));
});

export const loadCart = async () => {
  const response = await getCart(get(cart));
  cart.set(response.data);
  
  if (window.hasOwnProperty('hydrant')) window.hydrant.cart();
}

export const deliveryServices = writable();
export const paymentServices = writable();

let fetchedLockerPoint = null;
try { fetchedLockerPoint = JSON.parse(localStorage.getItem(lockerPointStorageKey(get(cart)?.token))); } catch(e) { /* corrupted */ }
export const lockerPoint = writable(fetchedLockerPoint || null);

lockerPoint.subscribe(value => {
  const token = get(cart)?.token;
  if (token) localStorage.setItem(lockerPointStorageKey(token), JSON.stringify(value));
});

export const Stages = Object.freeze({
  CART:         
    {name: 'Koszyk'},
  FORM:         
    {name: 'Informacje'},
  SUMMARY:      
    {name: 'Podsumowanie'},
  PLACED:      
    {name: 'Potwierdzenie zamówienia'}
});

export const stage = writable(Stages.CART);
